/**
 * ModuleUnavailable — the clean "not available on this install" state. The ai-assistant router is
 * MOUNTED on a local install (hybrid), but per the cloud-only degradation contract, when an endpoint
 * 404s (the module is genuinely un-mounted on an install) the screen renders this instead of a
 * retry-able error. Glyph + title + text (never color-only); no retry CTA (it will not appear).
 */
import { useT } from "@/app";
import { EmptyState } from "@/ui";

export function ModuleUnavailable() {
  const { t } = useT();
  return (
    <EmptyState glyph="⊘" title={t("ai.unavailable.title")} description={t("ai.unavailable.desc")} />
  );
}
